import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { fritzschoff } from '@env/secrets';

@Injectable({
  providedIn: 'root'
})
export class ImportGuard implements CanActivate {
  canActivate() {
    return localStorage.getItem('password') === fritzschoff.passwords.tonteppich.import;
  }
}
